function isEmail (email) {
  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return !email || re.test(email) || 'It must be an email'
}

function maxLength (len) {
  return function (val) {
    return (val && val.length <= minLength) || `Maximum length is ${len} chars`
  }
}

function minLength (len) {
  return function (val) {
    return (val && val.length >= minLength) || `Minimum length is ${len} chars`
  }
}

function required (val) {
  return !!val || 'Required'
}

export {
  isEmail,
  maxLength,
  minLength,
  required
}
